import React from 'react';
import PropTypes from 'prop-types';
import CorrectAlertIcon from '@common/images/alert_icon_correct.svg';
import {Image} from '@learningblocks/shared-components/lib/Image';
import {useTranslation} from 'react-i18next';

import './style.scss';

const ITEM_RESULT = {
  YES: 'Yes',
  NO: 'No',
};

export function ListItem(props) {
  const {t} = useTranslation();

  const TRANSLATION_KEY =
    props.text +
    (props.isSuccess ? ITEM_RESULT.YES : ITEM_RESULT.NO) +
    '.string';

  const renderAlertIcon = () =>
    props.isSuccess ? (
      <Image className='mc_warningItem_icon' src={CorrectAlertIcon} alt=""/>
    ) : (
      <Image className='mc_warningItem_icorrectIcon' src={CorrectAlertIcon} alt=""/>
    );

  return (
    <div className={`mc_warningItem ${props.isSuccess ? "mc_warningItem_pass" : ""}`}>
      <span className='mc_warningItem_text'>{t(TRANSLATION_KEY)}</span>
      {renderAlertIcon()}
    </div>
  );
}

ListItem.propTypes = {
  /**
   * bool value that specifies if the condition is success or not
   */
  isSuccess: PropTypes.bool,
  /**
   * text that specifies the warning message
   */
  text: PropTypes.string,
};

ListItem.defaultProps = {
  text: '',
};
